
export const TrackingImage = ({ media }: any) => {
    return (
        <img src={`${process.env.NEXT_PUBLIC_API_URL}media/${media.slug}/view`} className="hidden" />
    )
}